import type { CustomLinkProps } from '~shared/ui/atoms/Buttons/SmartLink/types';

import type { SmartElementProps } from './types';

export function isLinkProps(
	props: SmartElementProps
): props is CustomLinkProps & {
	ref?: React.RefObject<HTMLAnchorElement | null>;
	disabled?: boolean;
} {
	return 'href' in props && Boolean(props.href);
}

export function isLabelProps(
	props: SmartElementProps
): props is React.LabelHTMLAttributes<HTMLLabelElement> {
	return 'htmlFor' in props;
}

export function isButtonProps(
	props: SmartElementProps
): props is React.ButtonHTMLAttributes<HTMLButtonElement> {
	return 'onClick' in props || 'type' in props;
}
